import React, { Component } from 'react';
import '../App.css';
import '../styles/paperless-trees.css';
import Fade from 'react-reveal/Fade';
import { HashLink as Link } from 'react-router-hash-link';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

import paperlessTreesBannerImage from '../assets/paperless-trees/Panel-Planet-Card.svg';

import treesIcon from '../assets/paperless-trees/trees-icon.png';
import paperlessTreesLogo from '../assets/paperless-trees/paperless-trees-logo.png';
import oneTreePlantedLogo from '../assets/paperless-trees/one-tree-planted.png';
import earthDayNetLogo from '../assets/paperless-trees/earth-day-net.png';
import worldMap from '../assets/paperless-trees/Map.gif';

// How it works section //
import Calendar from '../assets/paperless-trees/calendar.png';
import Graph from '../assets/paperless-trees/graph.png';
import Plant from '../assets/paperless-trees/plant.png';

class PaperlessTrees extends Component {

  constructor(props) {
    super(props);
    this.state = {
      didViewCountUp: false
    }
  }

  render() {
    return (
      <section id="paperless-trees-section">
          <div id="paperless-trees-section-1">
            <div className="section-width-wrapper banner-wrapper">
              <div className="banner-text section-title-text-wrapper">
                <p className="section-header">
                DO IT FOR THE PLANET
                </p>
                <p className="section-body">
                  Your choice to go paperless matters.
                </p>
              </div>
              <img className="banner-image" src={paperlessTreesBannerImage} alt={''} />
              <div className="down-button-container">
                <Link to={`/slides#for-employers-section-2`}
                  className="down-button-background">
                  <i className="fa fa-angle-down" />
                </Link>
              </div>
            </div>
            <div className="down-button-container">
              <Link to={`/slides#paperless-trees-section-2`}
                className="down-button-background">
                <i className="fa fa-angle-down" />
              </Link>
            </div>
          </div>
          <div id="paperless-trees-section-2">
            <Fade bottom>
              <img src={treesIcon} alt={''} />
              <h2>Our Paperless Trees Project</h2>
              <p>Honors companies who have eliminated paper checks by<br />planting a grove of trees in the client’s name.</p>
            </Fade>
          </div>
          <div id="paperless-trees-section-4">
          <Fade bottom>
            <h2>Here's How It Works</h2>
            <div className="cards-contain">
              <div id="card-1" className="how-it-works-card" onClick={() => {
                const element = document.getElementById("card-1");
                element.classList.toggle("flip");
              }}>
                <div className="card-front">
                  <img src={Calendar} alt={''} />
                  <p>Set Your Target</p>
                  <div className="card-toggle-contain">
                    <span className="card-toggle card-1-toggle-1 selected-toggle"></span>
                    <span className="card-toggle card-1-toggle-2"></span>
                  </div>
                </div>
                <div className="card-back">
                  <p>Set an implementation date and announce your transition to 100% paperless payroll through direct deposit.</p>
                  <div className="card-toggle-contain">
                    <span className="card-toggle card-1-toggle-1"></span>
                    <span className="card-toggle card-1-toggle-2 selected-toggle"></span>
                  </div>
                </div>
              </div>
              <div id="card-2" className="how-it-works-card" onClick={() => {
                const element = document.getElementById("card-2");
                element.classList.toggle("flip");
              }}>
                <div className="card-front">
                  <img src={Graph} alt={''} />
                  <p>Reach 100% Paperless</p>
                  <div className="card-toggle-contain">
                    <span className="card-toggle card-1-toggle-1 selected-toggle"></span>
                    <span className="card-toggle card-1-toggle-2"></span>
                  </div>
                </div>
                <div className="card-back">
                  <p>We’ll help you reach 100% with the Fintwist Paycard for your unbanked employees.</p>
                  <div className="card-toggle-contain">
                    <span className="card-toggle"></span>
                    <span className="card-toggle selected-toggle"></span>
                  </div>
                </div>
              </div>
              <div id="card-3" className="how-it-works-card" onClick={() => {
                const element = document.getElementById("card-3");
                element.classList.toggle("flip");
              }}>
                <div className="card-front">
                  <img src={Plant} alt={''} />
                  <p>Let's Plant Those Trees!</p>
                  <div className="card-toggle-contain">
                    <span className="card-toggle selected-toggle"></span>
                    <span className="card-toggle"></span>
                  </div>
                </div>
                <div className="card-back">
                  <p>When you reach 100% direct deposit, we’ll plant a grove of trees in your name and send you our paperless award.</p>
                  <div className="card-toggle-contain">
                    <span className="card-toggle"></span>
                    <span className="card-toggle selected-toggle"></span>
                  </div>
                </div>
              </div>
            </div>
            <Link to={'/contact'}><button>Find out if your company qualifies!</button></Link>
            </Fade>
          </div>
          <VisibilitySensor
            onChange={(isVisible) => {
                this.setState({
                  didViewCountUp: true
                })
            }}
            delayedCall
          >
          <div id="paperless-trees-section-5">
          <div id="paperless-trees-planted-layer">
            <Fade bottom>
              <img src={paperlessTreesLogo} alt={''} />
                <CountUp
                  end={!this.state.didViewCountUp ? 23308 : 0}
                  separator=","
                >
                {({ countUpRef, start }) => (
                  <div>
                    <VisibilitySensor
                      onChange={start}
                      delayedCall
                    >
                    {({isVisible}) =>
                      <span ref={countUpRef} />
                    }
                    </VisibilitySensor>
                  </div>
                  )}
                </CountUp>
              <p>trees planted</p>
              <p>
                When you eliminate paper checks completely, we’ll plant a grove of trees in your company’s name to double-down on your commitment to sustainability. Since 2016, we’ve planted 23,308 trees for Fintwist clients through our Paperless Trees Project.
              </p>
              </Fade>
            </div>
          </div>
          </VisibilitySensor>
          <div id="paperless-trees-section-6">
            <div id="paperless-trees-section-6-layer">
              <div id="paperless-trees-section-6-content-container">
                <Fade bottom cascade>
                <div id="paperless-trees-section-6-logos-wrapper">
                  <img src={oneTreePlantedLogo} alt={''} />
                  <img src={earthDayNetLogo} alt={''} />
                </div>
                <div id="paperless-trees-section-6-text-wrapper">
                  <h2>
                    Our reforestation partners: One<br />Tree Planted and Earth Day Network.
                  </h2>
                  <p>
                    One Tree Planted and Earth Day Network both plant trees in North America, South America, Asia and Africa. Most of their projects help with restoration from forest fires and floods, as well as creating jobs, building communities, and protecting habitat for biodiversity.
                  </p>
                </div>
                </Fade>
              </div>
            </div>
          </div>
          <div id="paperless-trees-section-7">
              <div id="paperless-trees-section-7-title-wrapper">
                <Fade bottom>
                  <img src={treesIcon} alt={''} />
                  <h2>
                    Where will my trees be planted?
                  </h2>
                  <p>From Canada to California to Cameroon, your decision to switch to a paperless payroll will impact the world.</p>
                </Fade>
              </div>
              <Fade bottom>
                <img id="world-map" src={worldMap} alt={''} />
                <div id="world-map-countries-text">
                  <ul>
                    <li>North America</li>
                    <li>Canada</li>
                    <li>California</li>
                    <li>Colorado</li>
                    <li>Oregon</li>
                    <li>Puerto Rico</li>
                    <li>Mexico</li>
                  </ul>
                  <ul>
                    <li>Africa</li>
                    <li>Uganda</li>
                    <li>Cameroon</li>
                  </ul>
                  <div>
                    <ul>
                      <li>Asia + Pacific</li>
                      <li>India</li>
                    </ul>
                    <ul>
                      <li>South America</li>
                      <li>Brazil</li>
                    </ul>
                  </div>
                </div>
                <Link to={`/contact`}><button>Talk to a Fintwist representative</button></Link>
              </Fade>
          </div>
      </section>
    );
  }
}

export default PaperlessTrees;
